<template>
  <div class="card p-shadow-app">
    <h1>Veículos</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>
    <VehicleForm
      :show="showVehicleModel"
      v-on:cancel="showVehicleModel = false"
      v-on:vehicleCreated="vehicleCreatedOk"
    />
    <TabView @tab-change="onTabChange">
      <TabPanel header="Veículos">
    <div style="height: 65vh">
      <DataTable
        :value="vehicles"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        :sortOrder="1"
        sortField="category.name"
        responsiveLayout="scroll"
        removableSort
        sortMode="single"
        :scrollable="true"
        scrollHeight="flex"
        :autoLayout="true"
      >
        <template #empty> Não existem Veículos. </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <template #header>
          <div class="table-header">
            <Button
              icon="pi pi-plus"
              @click="showVehicleModel = true"
              v-if="$store.state.auth.user.isEsa || can('addFleetVehicles')"
            />
          </div>
        </template>
        <Column
          field="registration"
          filterField="registration"
          header="Matrícula"
          sortable
          filterMatchMode="contains"
        >
          <template #body="slotProps">
            <span
              v-if="
                $store.state.auth.user.isEsa || can('seeFleetVehicleDetails')
              "
              class="clickable-item"
              @click="$router.push(`/vehicle-details/${slotProps.data.id}`)"
              >{{ slotProps.data.registration }}</span
            >
            <span v-else>{{ slotProps.data.registration }}</span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="brand"
          filterField="brand"
          header="Marca"
          sortable
          filterMatchMode="contains"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="model"
          filterField="model"
          header="Modelo"
          sortable
          filterMatchMode="contains"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="office"
          filterField="office"
          header="Escritório"
          sortable
          filterMatchMode="contains"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="offices"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
        <Column
          field="current_condutor"
          filterField="current_condutor.conductor.username"
          header="Condutor"
          sortable
          filterMatchMode="contains"
        >
          <template #body="slotProps">
            {{
              slotProps.data.current_condutor
                ? slotProps.data.current_condutor.conductor.username +
                  " | " +
                  slotProps.data.current_condutor.start
                : ""
            }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="current_insurance"
          filterField="current_insurance.end"
          header="Seguro"
          sortable
          filterMatchMode="contains"
        >
          <template #body="slotProps">
            {{
              slotProps.data.current_insurance
                ? slotProps.data.current_insurance.insurer +
                  " | " +
                  slotProps.data.current_insurance.end
                : ""
            }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="registration_date"
          filterField="registration_date"
          header="Data Mat."
          sortable
          filterMatchMode="contains"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="acquisition_type"
          filterField="acquisition_type"
          header="Tipo de Aquisição"
          sortable
          filterMatchMode="contains"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="rental_end_date"
          filterField="rental_end_date"
          header="Fim do Aluguer"
          sortable
          filterMatchMode="contains"
        >
          <template #body="{ data }">
            {{ data.acquisition_type === 'Aluguer' ? data.rental_end_date : '' }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="active"
          header="Activo"
          sortable
          filterField="active"
          dataType="boolean"
        >
          <template #body="slotProps">
            {{ slotProps.data.active == 1 ? "Sim" : "Não" }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown
              v-model="filterModel.value"
              @input="filterCallback()"
              :options="[
                { value: 0, label: 'Não' },
                { value: 1, label: 'Sim' },
              ]"
              optionValue="value"
              optionLabel="label"
              class="p-column-filter"
              :showClear="true"
            >
            </Dropdown>
          </template>
        </Column>
      </DataTable>
    </div>
      </TabPanel>
      <TabPanel v-if="canSeeActivity" header="Atividade diária">
        <div class="p-d-flex p-ai-center p-flex-wrap p-mb-3">
          <label for="activityDate" class="p-mr-2">Data de início</label>
          <Calendar
            id="activityDate"
            v-model="activityDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :manualInput="false"
          />
          <Button
            label="Atualizar"
            icon="pi pi-refresh"
            class="p-button-outlined p-ml-2"
            :disabled="activityLoading"
            @click="loadActivity()"
          />
        </div>
        <p>Registos iniciados no dia selecionado.</p>
        <p v-if="activityError" role="alert">{{ activityError }}</p>
        <DataTable
          :value="activities"
          :loading="activityLoading"
          :lazy="true"
          :paginator="true"
          :rows="15"
          :first="activityFirst"
          :totalRecords="activityTotal"
          dataKey="id"
          class="p-datatable-sm"
          responsiveLayout="scroll"
          :autoLayout="true"
          @page="loadActivity($event.page + 1)"
        >
          <template #empty>
            {{ activityError || 'Não existem atividades para este dia.' }}
          </template>
          <template #loading>A carregar. Por favor Aguarde...</template>
          <Column field="registration" header="Matrícula" />
          <Column field="conductor.username" header="Condutor">
            <template #body="{ data }">
              {{ data.conductor ? data.conductor.username : '-' }}
            </template>
          </Column>
          <Column field="start" header="Início">
            <template #body="{ data }">{{ formatTimestamp(data.start) }}</template>
          </Column>
          <Column field="end" header="Fim">
            <template #body="{ data }">{{ formatTimestamp(data.end) }}</template>
          </Column>
        </DataTable>
      </TabPanel>
    </TabView>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api/";
import "vue-loading-overlay/dist/vue-loading.css";
import fleetService from "../services/fleet.service";
import VehicleForm from "../components/fleet/VehicleForm.vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { getOnlyDate } from "../helpers/helpers";
import { calendarDate, formatTimestamp } from "../helpers/targaTelematics";
export default {
  name: "Vehicles",
  components: { VehicleForm, TabView, TabPanel },
  data() {
    return {
      loading: true,
      vehicles: [],
      offices: [],
      activityDate: calendarDate(),
      activities: [],
      activityLoading: false,
      activityError: "",
      activityFirst: 0,
      activityTotal: 0,
      activitySequence: 0,
      activeTab: 0,
      filters: {
        registration: { value: null, matchMode: FilterMatchMode.CONTAINS },
        registration_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        rental_end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        acquisition_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
        brand: { value: null, matchMode: FilterMatchMode.CONTAINS },
        model: { value: null, matchMode: FilterMatchMode.CONTAINS },
        office: { value: null, matchMode: FilterMatchMode.EQUALS },
        active: { value: null, matchMode: FilterMatchMode.EQUALS },
        "current_condutor.conductor.username": {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
        "current_insurance.end": {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      showVehicleModel: false,
    };
  },
  computed: {
    canSeeActivity() {
      return this.can("seeFleetVehicles") && this.can("seeVehicleUseHistory");
    },
  },
  watch: {
    activityDate() {
      if (this.activeTab === 1) this.loadActivity();
    },
  },
  async created() {
    this.offices = await fleetService.getOffices();
    this.vehicles = await fleetService.getVehicles();
    this.loading = false;
  },
  beforeDestroy() {
    this.activitySequence++;
  },
  methods: {
    formatTimestamp,
    onTabChange(event) {
      this.activeTab = event.index;
      if (event.index === 1) this.loadActivity();
    },
    async loadActivity(page = 1) {
      if (!this.canSeeActivity) return;
      const sequence = ++this.activitySequence;
      this.activities = [];
      this.activityTotal = 0;
      this.activityFirst = (page - 1) * 15;
      this.activityError = "";
      this.activityLoading = false;
      if (!(this.activityDate instanceof Date) || !Number.isFinite(this.activityDate.getTime())) {
        this.activityError = "Selecione uma data válida.";
        return;
      }
      this.activityLoading = true;
      try {
        const response = await fleetService.getVehicleActivity(getOnlyDate(this.activityDate), page);
        if (sequence !== this.activitySequence) return;
        this.activities = response.data;
        this.activityTotal = response.meta.total;
      } catch (error) {
        if (sequence !== this.activitySequence) return;
        this.activityError = "Não foi possível carregar as atividades. Tente atualizar.";
        this.$toast.add({ severity: "error", summary: "Atividade diária", detail: this.activityError, life: 5000 });
      } finally {
        if (sequence === this.activitySequence) this.activityLoading = false;
      }
    },
    vehicleCreatedOk(vehicle) {
      this.vehicles.push(vehicle);
      return (this.showVehicleModel = false);
    },
  },
};
</script>
